import React, { useEffect, useState } from "react";

// Page Components:
// import ServiceList from "./serviceList/serviceList";
import ServicePaper from "../../components/paper/ServicePaper";

// MUI Components:
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

// Icons:
import DevicesOutlinedIcon   from '@mui/icons-material/DevicesOutlined';
import SettingsOutlinedIcon  from '@mui/icons-material/SettingsOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';

import { useTranslation } from 'react-i18next';


function Services() {
    const { t, i18n, ready } = useTranslation();


    // ** 17.12.2025: The function is not in use. need to verify iteration on translation file (ServicePaper.js is used instead)
    // const[aServices,setServices] = useState([]);
    // useEffect(() => {
    //     let selLang = i18n.language;
    //     if(i18n.getDataByLanguage(selLang)) {
    //         let services = i18n.getDataByLanguage(selLang).translation['service_section'].services;
    //             setServices(services);
    //     }
    // },[i18n])

    return(
        <div>

            <Box 
                display={'flex'}
                justifyContent={'space-between'}
                flexDirection={ 'column'}
                sx={{
                    "@media (min-width: 600px) and (max-width: 1024px)" : {
                        flexDirection:'row'
                    },
                    "@media (min-width:1024px) and (max-width:1280px)" : {
                        flexDirection:'row'
                    },
                    "@media screen and (min-width:1280px)" : {
                        flexDirection:'row'
                        }  
                    }}>
                    <ServicePaper 
                        paper_icon={<DevicesOutlinedIcon sx={{height:'3rem', width:'3rem'}}/>} 
                        oService={t('service_section.dev_srv', { returnObjects: true })} />

                    <ServicePaper 
                        paper_icon={<HandshakeOutlinedIcon sx={{height:'3rem', width:'3rem'}}/>} 
                        oService={t('service_section.consulting_srv', { returnObjects: true })} />

                    <ServicePaper 
                        paper_icon={<SettingsOutlinedIcon  sx={{height:'3rem', width:'3rem'}}/>} 
                        oService={t('service_section.itsupp_srv', { returnObjects: true })} />
                </Box>



        </div>
    )
}


export default Services;